import { Pipe, PipeTransform } from '@angular/core';
import { ICRMUser, ICustomerUser } from '@care-portals/api-interfaces';
import { Observable, map } from 'rxjs';
import { AdminUserFacade } from '../+store/admin-user/admin-user.facade';

const workflowUser: Partial<ICRMUser> = {
  firstName: 'Workflow',
  lastName: ''
};

const customerUser: Partial<ICustomerUser> = {
  firstName: 'Customer',
  lastName: ''
};

const systemUser: Partial<ICRMUser> = {
  firstName: 'System',
  lastName: ''
};

const noUser: Partial<ICRMUser> = {
  firstName: 'No user available',
  lastName: ''
};

@Pipe({
  name: 'userDetails',
  pure: true,
  standalone: true
})
export class UserDetailsPipe implements PipeTransform {
  // cachedUsers: Map<string, ICRMUser> = new Map<string, ICRMUser>();
  user;
  isLoaded = false;
  constructor(private readonly usersFacade: AdminUserFacade) {}
  transform(id: any): Observable<ICRMUser> | Observable<Partial<ICRMUser>> {
    this.usersFacade.getAdminUsers({}, false);
    return this.usersFacade.crmUsersEntities$.pipe(
      map(users => {
        if (id === 'workflow') {
          return workflowUser;
        } else if (id === 'customer') {
          return customerUser;
        } else if (id === 'system') {
          return systemUser;
        } else if (id) {
          return users[id];
        } else {
          return noUser;
        }
      })
    );
  }
}
